import { render, staticRenderFns } from "./ButtonGrid.vue?vue&type=template&id=87439696&"
import script from "./ButtonGrid.vue?vue&type=script&lang=js&"
export * from "./ButtonGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports